// Atlas Dashboard — Formatting utilities
// Handles IST conversion, duration formatting, and other display helpers.

export {
  formatIst,
  formatIstDate,
  formatIstTime,
  formatDuration,
  diffMinutes,
} from "@atlas/shared";

/**
 * Formats a percentage from a 0.0–1.0 value.
 * Example: 0.62 → "62%"
 */
export function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return `${Math.round(value * 100)}%`;
}

/**
 * Formats a number with commas (e.g., 12345 → "12,345").
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString("en-IN");
}

/**
 * Truncates a string to a maximum length, adding an ellipsis.
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + "...";
}
